export default __webpack_public_path__ + "static/media/ic_integration.df7b8a5f.svg";